module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/people_with_interaction-5690adb0e57a515b77a335d546410349.svg";